import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
export type RequirementFieldsForRemoveFormFragment = { __typename?: 'Requirement', id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, version?: string | null, category: Types.RequirementCategory, definition?: string | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string }>, tags: Array<{ __typename?: 'Tag', id: string }>, markets: Array<{ __typename?: 'Market', id: string }>, keywords: Array<{ __typename?: 'Keyword', id: string }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string }>, reference?: { __typename?: 'Reference', id: string } | null }> | null, childrenRefs?: Array<{ __typename?: 'Requirement', id: string, version?: string | null }> | null };

export const RequirementFieldsForRemoveFormFragmentDoc = gql`
    fragment RequirementFieldsForRemoveForm on Requirement {
  id
  name
  requirementId
  status
  version
  category
  definition
  vexClusters {
    id
    name
  }
  systemLevels {
    id
  }
  driveVariants {
    id
  }
  engineVariants {
    id
  }
  gearboxVariants {
    id
  }
  bodyworkVariants {
    id
  }
  activeTypeMarkets {
    id
  }
  tags {
    id
  }
  markets {
    id
  }
  keywords {
    id
  }
  documentReferences {
    referenceDocumentType
    requirementReferences {
      id
    }
    reference {
      id
    }
  }
  childrenRefs {
    id
    version
  }
}
    `;